export const ORGANIZATION_INVITATION_PERMISSIONS = {
  ADMIN: 'admin',
  GROUP_ADMIN: 'group_admin',
  USER: 'user'
}
